import React from 'react';
/**
 * DjayAvatar part — mouth per emotion.
 * Verbatim extraction of the former `renderMouth()` (incl. the `showMouth`
 * size gate and `showDetails` happy-mouth fill).
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface MouthProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showMouth: boolean;
  showDetails: boolean;
}
export function Mouth({
  emotion,
  colors,
  showMouth,
  showDetails
}: MouthProps) {
  if (!showMouth) return null;
  switch (emotion) {
    case 'excited':
    case 'celebrating':
    case 'proud':
      return <g className="djay-mouth" data-id="element-3190">
          <path d="M80 130 Q100 165 120 130 Z" fill={colors.mouthColor} data-id="element-3191" />
          <path d="M90 145 Q100 155 110 145 Z" fill="#EF4444" data-id="element-3192" />
        </g>;
    case 'surprised':
      return <g className="djay-mouth" data-id="element-3193">
          <ellipse cx="100" cy="138" rx="6" ry="10" fill={colors.mouthColor} data-id="element-3194" />
        </g>;
    case 'thinking':
      return <g className="djay-mouth" data-id="element-3195">
          <path d="M90 135 Q95 132 100 135 T110 135" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3196" />
        </g>;
    case 'sleeping':
      return <g className="djay-mouth" data-id="element-3197">
          <path d="M95 138 Q100 142 105 138" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3198" />
        </g>;
    case 'pointing':
      return <g className="djay-mouth" data-id="element-3199">
          <path d="M90 135 Q105 142 115 130" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3200" />
        </g>;
    case 'encouraging':
      return <g className="djay-mouth" data-id="element-3201">
          <path d="M85 135 Q100 145 115 135" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3202" />
        </g>;
    case 'happy':
    default:
      return <g className="djay-mouth" data-id="element-3203">
          <path d="M82 133 Q100 152 118 133" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3204" />
          {showDetails && <path d="M85 134 Q100 148 115 134" fill={colors.mouthColor} fillOpacity="0.15" data-id="element-3205" />}
        </g>;
  }
}